(function () {
  'use strict';

  angular
    .module('app.product-attributes', [])

    /* @ngInject */
    .directive('productAttributesSliders', function () {
      return {
        restrict: 'E',
        require: {
          productCtrl: '?^^productDetail'
        },
        bindToController: {
          sliders: '<'
        },
        controllerAs: 'attributesCtrl',
        /* @ngInject */
        controller: function () {
          var ctrl = this;

          ctrl.$onInit = function () {
            ctrl.sliders = _.cloneDeep(ctrl.sliders);
            ctrl.productCtrl.attributes = [];
            _.each(ctrl.sliders, function (slider, key) {
              slider.key = key;
              var steps = [];
              _.each(slider.Values, function (attr, index) {
                attr.value = parseInt(attr.Value);
                if (index === 0) {
                  slider.min = attr.value;
                }
                if (index === slider.Values.length - 1) {
                  slider.max = attr.value;
                }
                steps.push({
                  value: attr.value,
                  key: attr.Key
                });
                if (attr.Selected) {
                  slider.value = attr.value;
                  slider.selected = true;
                }
                slider.options = {
                  stepsArray: steps,
                  translate: function (value) {
                    return !slider.selected ? '' : value + ' €';
                  },
                  onStart: function () {
                    slider.selected = true;
                  },
                  // eslint-disable-next-line
                  onEnd: function (id, value) {
                    if (value === slider.lastValue) return;
                    slider.lastValue = value;
                    ctrl.productCtrl.attributes[slider.key] = _.find(steps, {'value': value}).key;
                    ctrl.productCtrl.changeAttribute();
                  }
                };
              });
            });

            console.info({ctrl: ctrl});
          };
        }
      };
    });

})();
